import React, { HTMLProps } from "react";
import { NavLink } from "react-router-dom";

import { ButtonNav, TextNav, Container } from "./styles";

interface ButtonNavigatorProps extends HTMLProps<ButtonNavigatorProps> {
  name: string;
  isActive?: boolean;
  onClick?: () => void;
  index?: number;
  indexMenu?: number;
  url: string;
}

const ButtonNavigator: React.FC<ButtonNavigatorProps> = ({
  name,
  isActive,
  onClick,
  index,
  indexMenu,
  url,
}) => {
  return (
    <Container>
      <NavLink
        className={({ isActive }) =>
          isActive ? "active-link" : "inactive-link"
        }
        to={url}
        end
      >
        <ButtonNav
          onClick={onClick}
          index={index}
          isActive={isActive}
          indexMenu={indexMenu}
        >
          <TextNav isActive={isActive}> {name} </TextNav>
        </ButtonNav>
      </NavLink>
    </Container>
  );
};

export default ButtonNavigator;
